const _ = require('lodash');

const Collection = require('../entities/collection');

const AccessContext = require('./contexts/access-context');

const {
  UUID_REGEX
} = require('../utils/constants');

const updateSubModelsForEdit = (collection
/*: Collection*/
, key
/*: string*/
, fetchModel
/*: id => Promise<Object>*/
, ids
/*: Array<string>*/
= collection[key] || [], {
  /*: { filterMissing: boolean }*/

  filterMissing
} = {}) =>
/*: Promise<Collection>*/
{
  /** Filter out anything that can't possibly be an ID
   *  in an attempt at simple self-healing
   */
  const filteredIds = ids.filter(id => _.isString(id) && UUID_REGEX.test(id));
  return Promise.all(filteredIds.map(id => fetchModel(id).catch(err => {
    if (filterMissing && err.status === 404) return null;
    return Promise.reject(err);
  }))).then(models => {
    const filteredModels = models.length ? models.filter(item => item != null) // allow fetchModel to filter specific results by returning null
    : undefined;
    /* eslint-disable-next-line no-param-reassign */

    collection[key] = filteredModels && filteredModels.length ? filteredModels : undefined;
    return collection;
  });
};

const updateSubModelsForUpdate = (collection
/*: Collection*/
, key
/*: string*/
) =>
/*: Promise<Collection>*/
{
  const models = collection[key] || [];
  /* eslint-disable-next-line no-param-reassign */

  collection[key] = models.map(m => m.id);
  return Promise.resolve(collection);
};

class CollectionsRepoHelper {
  constructor(client
  /*: ApiClient*/
  , context
  /*: AccessContext*/
  ) {
    this.client = client;
    this.context = context;
  }
  /** Get Extended Fields */


  updateFilterCategoriesForEdit(collection
  /*: Collection*/
  )
  /*: Promise<Collection>*/
  {
    const fetchCategory = id => this.client.categories.details(id);

    return updateSubModelsForEdit(collection, 'filterCategories', fetchCategory, undefined, {
      filterMissing: true
    });
  }

  updateBusinessesForEdit(collection
  /*: Collection*/
  )
  /*: Promise<Collection>*/
  {
    const {
      propertyId
    } = this.context.serialize();

    const fetchBusiness = id => this.client.properties.for(propertyId).businesses.for(id).details();

    return updateSubModelsForEdit(collection, 'businesses', fetchBusiness, collection.businessIds, {
      filterMissing: true
    });
  }

  updateOffersForEdit(collection
  /*: Collection*/
  )
  /*: Promise<Collection>*/
  {
    const {
      propertyId
    } = this.context.serialize();

    const fetchOffers = id => this.client.properties.for(propertyId).offers.for(id).coreDetails();

    return updateSubModelsForEdit(collection, 'offers', fetchOffers, collection.offerIds, {
      filterMissing: true
    });
  }

  updateLocationsForEdit(collection
  /*: Collection*/
  )
  /*: Promise<Collection>*/
  {
    const {
      propertyId
    } = this.context.serialize();

    const fetchLocation = id => this.client.properties.for(propertyId).locations.search({
      locationId: id
    }).then(locationsList => locationsList.items[0]);

    return updateSubModelsForEdit(collection, 'locationIds', fetchLocation, collection.locationIds, {
      filterMissing: true
    });
  }
  /** Set Extended Fields */

  /* eslint-disable-next-line class-methods-use-this */


  updateFilterCategoriesForUpdate(collection
  /*: Collection*/
  )
  /*: Promise<Collection>*/
  {
    return updateSubModelsForUpdate(collection, 'filterCategories');
  }
  /* eslint-disable-next-line class-methods-use-this */


  updateBusinessesForUpdate(collection
  /*: Collection*/
  )
  /*: Promise<Collection>*/
  {
    return updateSubModelsForUpdate(collection, 'businessIds');
  }
  /* eslint-disable-next-line class-methods-use-this */


  updateOffersForUpdate(collection
  /*: Collection*/
  )
  /*: Promise<Collection>*/
  {
    return updateSubModelsForUpdate(collection, 'offerIds');
  }
  /* eslint-disable-next-line class-methods-use-this */


  updateLocationsForUpdate(collection
  /*: Collection*/
  )
  /*: Promise<Collection>*/
  {
    return updateSubModelsForUpdate(collection, 'locationIds');
  }

}

module.exports = CollectionsRepoHelper;